<template>


<div class="group_28 flex-row">
        <div class="group_29 flex-col justify-between">
          <div class="text-wrapper_31 flex-row justify-between">
            <span class="text_66">联系方式：13220190868</span>
            <span class="text_67">Email：info&#64;ktangtang.com</span>
          </div>
          <span class="text_68">官网地址：https://ktangtang.com</span>
          <span class="text_69">公司地址：&nbsp;北京市顺义区中关村科技园区顺义园汇海中路7号院221-03室</span>
        </div>
        <div class="text-wrapper_32 flex-col justify-between">
          <span class="text_70">公众号：以动健康</span>
          <span class="text_71">官方微博：&#64;以动健康</span>
          <span class="text_72">京ICP备19026627号</span>
        </div>
        <div class="image-text_22 flex-col justify-between">
          <img
            class="image_28"
            referrerpolicy="no-referrer"
            v-lazy="'https://web-cdn.ktangtang.com/official-website/footer/FigmaDDSSlicePNGb44291ba8e983b81bea2ee1b1a2e5ed9.png'"
          />
          <span class="text-group_15">公众号二维码</span>
        </div>
      </div>
      
    </template>
    
    
      
      <script>
        export default {
          data() {
            return {
              activeIndex: '1',
              activeIndex2: '1',
              url: '/lanhu_shouyegaiban'
            };
          },
          async mounted(){
            this.url = this.$route.path
              console.log(this.$route.path)
          },
          methods: {
            handleSelect(key, keyPath) {
              console.log(key, keyPath);
            }
          }
        }
      </script>
      <style scoped lang="css" src="./assets/index.rem.css" />